import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'

import { Salt } from './Salt'
import { FundingAmount } from './FundingAmount'
import { ImplementationContract } from './ImplementationContract'
import { InitializationCalldata } from './InitializationCalldata'

// "primaryContractDeployment": {
//   "salt": "0x65845cc4e77a4c76db68c2e9c5f1606e818cf077bfeedbb19c0d89d6a1c255f0",
//   "fundingAmount": 0,
//   "implementationContract": "0x91488301...",
//   "initializationCalldata": "0x91488301...",
// },

export const PrimaryContractDeploymentPropsSchema = z.object({
  salt: z.instanceof(Salt),
  fundingAmount: z.instanceof(FundingAmount),
  implementationContract: z.instanceof(ImplementationContract),
  initializationCalldata: z.instanceof(InitializationCalldata),
})

export type PrimaryContractDeploymentProps = z.infer<
  typeof PrimaryContractDeploymentPropsSchema
>

export class PrimaryContractDeployment extends ValueObject<PrimaryContractDeploymentProps> {
  public getSalt(): Salt {
    return this.props.salt
  }

  public getFundingAmount(): FundingAmount {
    return this.props.fundingAmount
  }

  public getImplementationContract(): ImplementationContract {
    return this.props.implementationContract
  }

  public getInitializationCalldata(): InitializationCalldata {
    return this.props.initializationCalldata
  }

  public static create(
    props: PrimaryContractDeploymentProps
  ): PrimaryContractDeployment {
    const validatedProps = PrimaryContractDeploymentPropsSchema.parse(props)
    return new PrimaryContractDeployment(validatedProps)
  }
}
